export default {"src":"/_next/static/media/article-bg.724bbb88.svg","height":700,"width":5120,"blurWidth":0,"blurHeight":0};